export function sleep(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export const getLocalePrimaryTag = (locale: string): string => {
    if (locale == null) return undefined;
    return locale.replace("_", "-").split("-")[0];
};

export const isInternalClient = (clientId: string) => window.selfClientId === clientId;
